import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Irfan Pasha. Built with React.</p>
    </footer>
  );
}

export default Footer;